module.exports = __webpack_public_path__ + "img/how-it-works-promoters-1.0a1cc92c.png";